import { FusaOrganizationParams } from '@/backend/access/fusaOrganization/types';
import { File } from './file';

export class FusaOrganization {
  id: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  title: string;
  description: string;
  enterpriseId: string;
  propelOrgId: string;
  file?: File;

  constructor(params: FusaOrganizationParams) {
    this.id = params.id;
    this.createdAt = params.createdAt;
    this.updatedAt = params.updatedAt;
    this.title = params.title;
    this.description = params.description;
    this.enterpriseId = params.enterpriseId;
    this.propelOrgId = params.propelOrgId;
    this.file = params.file ? new File(params.file) : undefined;
  }
}
